/**
 * Fonctionnalités activables par instance — gravées au build (Vite), comme
 * VITE_API_URL : l'image web est construite par instance (voir deploy.yml).
 * Purement cosmétique : c'est l'API qui fait autorité (RECORDING_ENABLED).
 */

/**
 * Enregistrement des réunions — nécessite un serveur LiveKit Egress. Une
 * instance sans Egress (ex. Copyhouse au démarrage) le désactive
 * (VITE_RECORDING_ENABLED=false) : pas de bouton « Rec », pas de page admin.
 */
export const RECORDING_ENABLED = import.meta.env.VITE_RECORDING_ENABLED !== 'false';
